import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { useSessionPermission } from '@btime/react-session'

import { cleanRequest } from './cleanRequest'
import { formsClient, generalClient, serviceOrdersClient } from '../../../../utils/apollo/api'
import { mergeRequestStates } from '../../../../utils/helpers/mergeRequestStates'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useDuplicateChecker } from '../../../../utils/hooks/duplicateServiceOrders'
import { validateFieldValues } from '../../../../utils/helpers/fields'

const MUTATION = gql`
  mutation UpsertServiceOrder($input: ServiceOrderInput) {
    upsertServiceOrder(input: $input) {
      id
    }
  }
`

const validate = (form, setErrors, hidePlace) => {
  const errors = [
    ...appendIf(!hidePlace && !form.place?.id, { path: ['place'], message: 'Campo obrigatório' }),
    ...appendIf(!form.checklist?.id, { path: ['checklist'], message: 'Campo obrigatório' }),
    ...validateFieldValues(form)
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveServiceOrder = () => {
  const hidePlace = useSessionPermission('hideServiceOrdersPlace')
  const closeModal = useCloseModal()
  const [checkDuplicates, findDuplicatesState] = useDuplicateChecker()
  const [request, upsertServiceOrdersState] = useMutation(MUTATION, {
    refetchQueries: ['ServiceOrders', 'ServiceOrder', 'FormReplies', 'Form', 'ServiceOrdersCount'],
    client: serviceOrdersClient
  })

  const handleRequest = async (form, actions, params) => {
    const input = cleanRequest(form)

    const { setErrors } = actions
    const isValid = validate(form, setErrors, hidePlace)

    if (isValid) {
      const [safeInputs] = await checkDuplicates([input])
      if (!safeInputs?.length) return

      return request({ variables: { input: safeInputs[0] } }).then(resp => {
        if (!resp.errors) {
          formsClient.reFetchObservableQueries()
          generalClient.reFetchObservableQueries()
          closeModal()
          if (!!params?.onSuccess) params.onSuccess(resp?.data?.upsertServiceOrder)
        }
      })
    }
  }

  return [handleRequest, mergeRequestStates(findDuplicatesState, upsertServiceOrdersState)]
}
